(function() {
    'use strict';

    angular
        .module('app')
        .controller('mobileTriggerController', mobileTriggerController);

    function mobileTriggerController($location, modalService) {
        init();

        function init() {
            modalService.login();
            $location.path('/login');
        }
    }
})();
